// pages/Dashboard.jsx
import ForgotPassword from "../../components/home/authComponents/ForgotPassword";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ForgotPassword />
    </HomeLayout>
  );
}
